import axios from "axios";

const apiClient = axios.create();

// Automatically attach the server-issued JWT only to chat-assistant server requests
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('apiToken');
    if (token && config.url?.includes('/api/')) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Retry once on ECONNABORTED (stale connection after tab was backgrounded)
apiClient.interceptors.response.use(null, async (error) => {
    const config = error.config;
    if (error.code === 'ECONNABORTED' && !config._retried) {
        config._retried = true;
        return apiClient(config);
    }
    return Promise.reject(error);
});

export const getApi = async (url, headers={}) => {
    try {
        return await apiClient.get(url, { headers });
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
}

export const postApi = async (url, headers, body, signal) => {
    try{
        return await apiClient.post(url, body, {
            headers, 
            signal,
        })
    }
    catch(err){
        console.error('API Error:', err);
        throw err;
    }
}